import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp, Container } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import UIManager from "../../core/components/ui/UiBuilder";
import * as PIXI from 'pixi.js';
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";
import { isMobile } from "react-device-detect";
import withbaseGameReconstructionConfiguration from "./configuration/withbaseGameReconstructionConfiguration";
import { actions as buttonActions } from "../../core/reducers/buttonPanelReducer";
import { CURRENCY, TIMER } from "../../core/utills";
import { actions as baseGameReconstructionActions } from '../../gamereducer/baseGameReconstructionReducer';
import { actions as gridsActions } from "../../core/reducers/gridStateReducer";
import { actions as asyncActions } from "../../core/reducers/asyncServerResponseReducer";
import { actions as winpresentationAction } from "../../core/reducers/winPresentationReducer";
import { actions as flowManagerAction } from "../../core/reducers/flowManagerReducer";



interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;


}

interface IStateToProps {
    [x: string]: any;

}

interface IDispatchToProps {

}

interface IState {
    [x: string]: any;
}

class baseGameReconstruction extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected baseGameReconstruction: any;
    protected ui_mode: string;
    protected displayUI: any;
    protected spaceBarSpinstoreValue: boolean;
    protected multiplierValue: number = 0;

    protected optionCounter: number = 1;

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.state = {
            uiElements: [],
            lang: "en"
        }
        this.baseGameReconstruction = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }

        this.displayUI = this.props.data.COMPONENTS[0].child.filter(this.checkUiMode.bind(this));
        this.spaceBarSpinstoreValue = false;

    }

    checkUiMode(uimodeobj: any) {

        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }


    bindUI() {
        this.layoutChange(this.props.layoutMode);
    }

    componentDidMount() {
        this.bindUI();
        if (this.props.showBannerForReconstruction) {
            let timer = TIMER.TimerManager.createTimer(500);
            timer.on('end', (e: any) => {
                e.remove();
                this.props.setAllButtonDisable();
            })
            timer.start();
        }
    }
    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        // if (nextProps.showBannerForReconstruction) {
        //     if (nextProps.spinResponseReceived && nextProps.spinResponseReceived !== this.props.spinResponseReceived) {
        //         this.props.flowManagerCalled(false);
        //         const {
        //             startGridSpin
        //         } = nextProps;
        //         startGridSpin();
        //         this.props.reconstructionBannerShow(false);
        //         return false;
        //     }
        // }
        if (nextProps.layoutMode !== this.props.layoutMode) {
            this.layoutChange(nextProps.layoutMode);
            return false;
        }

        return true;
    }





    handleEvent = (e: any) => {

        switch (e.target.name) {
            case "baseGameSpinbtn":
                this.onSpin();

                return;
            default:
                return 'No buttons';
        }
    }


    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any,) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        }
        )
    }
    onSpin() {
        this.props.reconstructionBannerShow(false);
        this.props.setAllButtonDisable();
        this.props.setblastStarted();

    }

    render() {
        if (!this.props.showBannerForReconstruction) {
            return (<></>)
        }
        return (
            <UIManager id={"baseGameReconstruction"} name={"baseGameReconstruction"} type={"Container"}
                ref={i => this.baseGameReconstruction = i} configGame={this.props.configGame}
                app={this.app} >
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            id={i.id} {...i} app={this.app} configGame={this.props.configGame} ClickHandler={this.handleEvent}

                            scope={this} />
                    )
                }
            </UIManager>

        )
    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, 'applicationState' | 'baseGameReconstructionState' | 'gridsState'>): IStateToProps =>
    ({
        layoutMode: state.applicationState.layoutMode,
        showBannerForReconstruction: state.baseGameReconstructionState.showBannerForReconstruction,
        spinResponseReceived: state.gridsState.spinResponseReceived,

    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
        setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),
        reconstructionBannerShow: (showBannerForReconstruction: boolean): any => dispatch(baseGameReconstructionActions.reconstructionBannerShow(showBannerForReconstruction)),
        startGridSpin: (): any => dispatch(gridsActions.startSpin()),
        setApplicationSpinButtonClicked: (isClicked: boolean): any => dispatch(buttonActions.setApplicationSpinButtonClicked(isClicked)),
        getApplicationSpinResponse: (): any => dispatch(asyncActions.getApplicationSpinResponse()),
        stopWinPresentation: (): any => dispatch(winpresentationAction.stopWinPresentation()),
        resetReelState: (): any => dispatch(gridsActions.resetReelState()),
        flowManagerCalled: (callFlowManager: boolean): any => dispatch(flowManagerAction.flowManagerCalled(callFlowManager)),
        setblastStarted: (): any => dispatch(gridsActions.blastStart()),

    }))(withbaseGameReconstructionConfiguration(baseGameReconstruction)));